<template>
  <div v-if="client">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <router-link :to="{name: 'clients'}">powrót</router-link>
              <router-link class="btn btn-primary ml-auto"
                           v-has-permissions="50"
                           :to="{name: 'clientMerge', clientID: client.clientId}">
                Połącz klienta
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-address-book-o"></i>
            Dane klienta
            <div class="card-header-actions">
              <a class="card-header-action"
                 target="_blank"
                 v-bind:href="'/api/clients/envelope/print/' + client.clientId">
                Wydrukuj kopertę
              </a>
              <a href="#" @click.prevent="toggleIsActive()"
                 v-has-permissions="50"
                 v-if="isClientViewMode"
                 class="card-header-action">
                <span v-if="client.isActive">Archiwizuj klienta</span>
                <span v-if="!client.isActive">Aktywuj klienta</span>
              </a>
              <a href="#" @click.prevent="toggleClientViewMode()" v-has-permissions="50" class="card-header-action">
                <span v-if="isClientViewMode">Edytuj</span>
                <span v-if="!isClientViewMode">Anuluj</span>
              </a>
            </div>
          </div>
          <client-details-card v-if="isClientViewMode" v-bind:client="client"></client-details-card>
          <div class="card-body">
            <form v-if="!isClientViewMode" @submit.prevent="updateClientData()">
              <div class="row form-group">
                <div class="col-md-5">Imiona</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.firstName"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Nazwisko</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.lastName"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">PESEL</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.pesel"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Ulica</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.street"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Nr domu</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.streetNo"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Nr mieszkania</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.flatNo"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Miasto</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.city"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Kraj</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.country"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Telefon</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.phone1"/>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">Telefon2</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.phone2"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Tel. komórkowy</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.cellPhone"/>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">E-mail</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.email1"/>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">E-mail2</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.email2"/>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">Dowód nr</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.personalId"/>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">comments</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.comments"/>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">Zgoda na przetwarzanie danych</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="clientModel.zgodaNpdo">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">Zgoda na wyświetlanie danych i rachunków</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="clientModel.zgodaNprd">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">Zgoda marketingowa</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="clientModel.zgodaNoih">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-5">Zgoda E-mail</div>
                <div class="col-md-7">
                  <select class="form-control" v-model="clientModel.zgodaEmail">
                    <option value="1">TAK</option>
                    <option value="0">NIE</option>
                  </select>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">kartamagn</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="clientModel.kartamagn"/>
                </div>
              </div>
              <button type="submit" class="btn btn-primary">Zatwierdź</button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-dollar"></i>
            Program lojalnościowy
          </div>
          <div class="card-body" v-if="client">
            <div class="row">
              <div class="col-md-5">Status</div>
              <div class="col-md-7">
                <span v-if="client.parentClientId">
                  <span class="badge badge-secondary mr-2">Subkonto </span>
                </span>
                <span v-if="!client.parentClientId">
                  <span class="badge badge-success mr-2">Konto główne</span>
                </span>
                <a href @click.prevent="startParentClientUpdate()" v-has-permissions="50">Zmień</a>
              </div>
            </div>
            <div class="row" v-if="client.parentClientId">
              <div class="col-md-5">Konto główne</div>
              <div class="col-md-7">{{ client.parentClientFullName }} (ID: {{ client.parentClientId }})</div>
            </div>
            <div class="row">
              <div class="col-md-5">Suma wydatków</div>
              <div class="col-md-7">{{ client.loyaltyBalance | currency }}</div>
            </div>
            <div class="row">
              <div class="col-md-5">{{ $t('loyaltyCards.cardType') }}</div>
              <div class="col-md-7">
                {{ $t('loyaltyCards.level.' + client.actualLoyaltyGroup)}}
                <span v-if="client.applicableLoyaltyGroup && client.applicableLoyaltyGroup > client.actualLoyaltyGroup">
                  (do wydania {{ $t('loyaltyCards.level.' + client.applicableLoyaltyGroup)}})
                </span>
              </div>
            </div>
            <div class="row" v-if="!client.parentClientId">
              <div class="col-md-5">Saldo początkowe</div>
              <div class="col-md-7">
                {{ client.initialLoyaltyBalance | currency }}
                <a href v-has-permissions="50" @click.prevent="startLoyaltyBalanceUpdate()">Zmień</a>
              </div>
            </div>
          </div>
        </div>
        <loyalty-card-create
            v-has-permissions="20"
            v-bind:client="client"
            @loyalty-cards-updated="onLoyaltyCardsUpdated()">
        </loyalty-card-create>
        <client-initial-loyalty-balance
            v-if="loyaltyBalanceUpdate"
            v-has-permissions="50"
            v-bind:client="client"
            @cancel-loyalty-balance-update="onLoyaltyBalanceUpdateCancel()"
            @client-updated="onClientUpdated()">
        </client-initial-loyalty-balance>
        <client-set-parent-client
            v-if="parentClientUpdate"
            v-has-permissions="50"
            v-bind:client="client"
            @cancel-parent-client-update="onParentClientUpdateCancel()"
            @client-updated="onClientUpdated()">
        </client-set-parent-client>
        <div v-if="sendToPlazaBranchNo">
          <div class="modal fade show" style="display: block;">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Dodaj klienta do systemu Plaza</h4>
                  <button class="close" type="button" @click="cancelSendToPlaza()" data-dismiss="modal"
                          aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p>Potwierdź utworzenie nowego klienta w systemie Plaza <strong>{{
                    $t(`branchName.${sendToPlazaBranchNo}.a`)}}</strong>.</p>
                  <div class="alert alert-warning" role="alert">
                    UWAGA! Dane z systemu PLAZA pojawią się w CRM dopiero po nocnej synchronizacji danych.
                  </div>
                  <button class="btn btn-primary mr-2" @click="sendToPlaza()" type="button">Wyślij</button>
                  <button class="btn btn-secondary" @click="cancelSendToPlaza()" type="button">Anuluj</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-backdrop fade show"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-tabs>
          <b-tab title="Faktury" active>
            <div v-if="!invoices.length">Klient nie posiada faktur</div>
            <table class="table" v-if="invoices.length">
              <thead>
              <tr>
                <th scope="col">{{ $t('invoices.invoiceDate')}}</th>
                <th scope="col">{{ $t('invoices.invoiceNumber') }}</th>
                <th scope="col">{{ $t('invoices.invoiceType') }}</th>
                <th scope="col">{{ $t('invoices.totalNet') }}</th>
                <th scope="col">{{ $t('invoices.totalGross') }}</th>
                <th scope="col">{{ $t('invoices.companyName') }}</th>
                <th scope="col">{{ $t('invoices.companyNip') }}</th>
                <th scope="col">{{ $t('branchName') }}</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="invoice in invoices" :key="invoice.invoiceId" class="invoice-row">
                <th scope="row">{{ invoice.invoiceDate | date }}</th>
                <td>{{ invoice.invoiceNumber }}</td>
                <td>{{ $t('invoices.invoiceTypes.' + invoice.invoiceType ) }}</td>
                <td>{{ invoice.totalNet | currency }}</td>
                <td>{{ invoice.totalGross | currency }}</td>
                <td>{{ invoice.companyName }}</td>
                <td>{{ invoice.companyNip }}</td>
                <td>{{ invoice.branchName }}</td>
                <td class="d-flex align-items-center">
                  <!--<span class="form-check form-check-inline">-->
                  <!--<input class="form-check-input"-->
                  <!--type="checkbox"-->
                  <!--:id="invoice.invoiceId"-->
                  <!--:name="invoice.invoiceId"-->
                  <!--@change="toggleInvoiceLoyaltyStatus(invoice)"-->
                  <!--v-model="invoiceLoyaltyCheckbox[invoice.invoiceId]"-->
                  <!--:disabled="!invoice.companyNip || invoice.companyNip === '0' || client.clientId !== invoice.loyaltyClientId">-->
                  <!--<label class="form-check-label" :for="invoice.invoiceId"></label>-->
                  <!--</span>-->
                  <span class="badge badge-success mr-1" v-if="client.clientId === invoice.loyaltyClientId">Program lojalnościowy</span>
                  <span class="badge badge-primary" v-if="client.clientId === invoice.clientId">Nabywca</span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-tab>
          <b-tab title="Meldunki">
            <div v-if="!stays.length">Klient nie posiada meldunków</div>
            <table class="table" v-if="stays.length">
              <thead>
              <tr>
                <th scope="col">{{ $t('branchName') }}</th>
                <th scope="col">{{ $t('stays.dateFrom')}}</th>
                <th scope="col">{{ $t('stays.dateTo') }}</th>
                <th scope="col">{{ $t('stays.pokojId') }}</th>
                <th scope="col">{{ $t('stays.meldunekId') }}</th>
                <th scope="col">{{ $t('stays.meldunekOsobaId') }}</th>
                <th scope="col">{{ $t('stays.osobaId') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="stay in stays" :key="stay.meldunekOsobaId" class="invoice-row">
                <td>{{ stay.branchName }}</td>
                <td>{{ stay.dateFrom | date }}</td>
                <td>{{ stay.dateTo | date }}</td>
                <td>{{ stay.pokojId }}</td>
                <td>{{ stay.meldunekId }}</td>
                <td>{{ stay.meldunekOsobaId }}</td>
                <td>{{ stay.osobaId }}</td>
              </tr>
              </tbody>
            </table>
          </b-tab>

          <b-tab title="Karty lojalnościowe">
            <div v-if="!loyaltyCards.length">Klient nie posiada kart lojalnościowych</div>
            <table class="table" v-if="loyaltyCards.length">
              <thead>
              <tr>
                <th scope="col">{{ $t('loyaltyCards.cardNumber')}}</th>
                <th scope="col">{{ $t('clients.fullName')}}</th>
                <th scope="col">{{ $t('loyaltyCards.cardType') }}</th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="card in loyaltyCards" :key="card.loyaltyId">
                <td>{{ card.cardNumber }}</td>
                <td>{{ card.fullName }}</td>
                <td>{{ $t('loyaltyCards.level.' + card.cardType )}}</td>
                <td>
                  <span class="badge badge-primary mr-1" v-if="client.clientId === card.clientId">Główna</span>
                  <span class="badge badge-success mr-1" v-if="client.clientId !== card.clientId">Dodatkowa</span>
                </td>
                <td>
                  <a class="card-header-action"
                     target="_blank"
                     v-bind:href="'/api/loyalty-cards/print/' + card.loyaltyId">
                    Wydrukuj kartę
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </b-tab>
          <b-tab title="Rekordy Plaza">
            <table class="table" v-if="client">
              <thead>
              <tr>
                <th scope="col">Obiekt</th>
                <th scope="col">OSOBA_ID</th>
                <th scope="col">Status</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="branch in client.branchesData" v-bind:key="branch.osobaId+branch.branchName">
                <td>{{ branch.branchName }}</td>
                <td>{{ branch.osobaId}}</td>
                <td>
                  <span v-if="branch.approvalRequired">
                    <span class="badge badge-danger mr-2">
                      Do zatwierdzenia
                    </span>
                    <router-link
                        :to="{name: 'manualPersonsDetails', params: {osobaId: branch.osobaId, branchId: branch.branchId }}">
                      Szczegóły
                    </router-link>
                  </span>
                  <span class="badge badge-success mr-2" v-if="!branch.approvalRequired">
                    Aktualny
                  </span>
                </td>
              </tr>
              <tr v-for="branch in missingBranches" v-bind:key="branch">
                <td>{{ $t(`branchName.${branch}.a`) }}</td>
                <td>
                  <a href
                     @click.prevent="requestSendToPlaza(branch)">
                    Wyślij do Plaza
                  </a>
                </td>
                <td>
                   <span class="badge badge-secondary mr-2">
                      Nie znaleziono
                    </span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-tab>
          <b-tab title="Historia zmian (CRM)">
            <div v-if="!clientsHistory.length">Brak historii dla wybranego klienta</div>
            <table class="table" v-if="clientsHistory.length">
              <thead>
              <tr>
                <th scope="col">Data do</th>
                <th scope="col">Zmienił</th>
                <th scope="col">{{ $t('clients.fullName') }}</th>
                <th scope="col">{{ $t('clients.address') }}</th>
                <th scope="col">{{ $t('clients.city') }}</th>
                <th scope="col">{{ $t('clients.pesel') }}</th>
                <th scope="col">{{ $t('common.actions') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(historyRow, index) in clientsHistory" v-bind:key="historyRow.clientId">
                <td>{{ historyRow.modificationDate | datetime }}</td>
                <td>
                  <span v-if="historyRow.modifier">
                    <span class="badge badge-primary">CRM</span>
                    {{ historyRow.modifier }}
                  </span>
                  <span v-if="historyRow.branchName">
                    <span class="badge badge-success">PLAZA</span>
                    {{ historyRow.branchName }}
                  </span>
                </td>
                <td>{{ historyRow.data.firstName }} {{ historyRow.data.lastName }}</td>
                <td>
                  {{ historyRow.data.street }}
                  {{ historyRow.data.streetNo }}
                </td>
                <td>
                  {{ historyRow.data.postalCode }}
                  {{ historyRow.data.city }}
                </td>
                <td>{{ historyRow.data.pesel }}</td>
                <td>
                  <a href @click.prevent="showHistoryDetails(historyRow, index)">Szczegóły</a>
                </td>
              </tr>
              </tbody>
            </table>
          </b-tab>

          <b-tab title="Konta dodatkowe" v-if="childClients.length">
            <table class="table">
              <thead>
              <tr>
                <th scope="col" @click="setOrderBy('lastName')">{{ $t('clients.fullName') }}</th>
                <th scope="col" @click="setOrderBy('street')">{{ $t('clients.address') }}</th>
                <th scope="col" @click="setOrderBy('city')">{{ $t('clients.city') }}</th>
                <th scope="col">{{ $t('clients.pesel') }}</th>
                <th scope="col" colspan="2">{{ $t('clients.clientId')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="childClient in childClients" v-bind:key="childClient.clientId">
                <td>{{ childClient.fullName }}</td>
                <td>{{ childClient.address }}</td>
                <td>{{ childClient.city }}</td>
                <td>{{ childClient.pesel }}</td>
                <td>{{ childClient.clientId}}</td>
              </tr>
              </tbody>
            </table>
          </b-tab>
        </b-tabs>
        <client-history-details
            v-if="clientHistoryDetails"
            @closed="closeHistoryRowDetails()"
            v-bind:client="clientHistoryDetails">
        </client-history-details>
      </div>
    </div>
  </div>
</template>

<script>
  import clients from '@Service/clients';
  import LoyaltyCardCreate from '@Component/loyalty-card-create';
  import ClientInitialLoyaltyBalance from '@Component/client-initial-loyalty-balance';
  import ClientSetParentClient from '@Component/client-set-parent-client';
  import ClientDetailsCard from '@Component/client-details-card';
  import ClientHistoryDetails from '@Component/client-history-details';
  import { toastSuccess, toastError } from '../helpers';

  export default {
    components: {
      ClientHistoryDetails,
      ClientInitialLoyaltyBalance,
      LoyaltyCardCreate,
      ClientSetParentClient,
      ClientDetailsCard,
    },
    data() {
      return {
        client: null,
        missingBranches: [],
        sendToPlazaBranchNo: null,
        clientModel: {},
        invoices: [],
        stays: [],
        loyaltyCards: [],
        childClients: [],
        clientsHistory: [],
        loyaltyBalanceUpdate: false,
        parentClientUpdate: false,
        clientHistoryDetails: null,
        isClientViewMode: true,
        invoiceLoyaltyCheckbox: {},
      };
    },
    methods: {
      toggleClientViewMode() {
        this.isClientViewMode = !this.isClientViewMode;
      },
      toggleInvoiceLoyaltyStatus(invoice) {
        clients.updateInvoiceLoyaltyStatus(invoice)
          .then(() => {
            toastSuccess(this.$t(`messages.clients.invoiceLoyaltyStatus.${invoice.loyaltyStatus ? 'off' : 'on'}.success`));
          })
          .catch(toastError)
          .then(() => this.onClientUpdated());
      },
      requestSendToPlaza(branchId) {
        this.sendToPlazaBranchNo = branchId;
      },
      cancelSendToPlaza() {
        this.sendToPlazaBranchNo = null;
      },
      sendToPlaza() {
        /** CAUTION this method can create as many persons in plaza as you run it. There has to be lock that after successfull request, there can no other request be performed */
        clients.sendToPlaza(this.client.clientId, this.sendToPlazaBranchNo)
          .then(() => {
            this.missingBranches = this.missingBranches.filter(i => i !== this.sendToPlazaBranchNo);
            this.sendToPlazaBranchNo = null;
            toastSuccess(this.$t(`messages.clients.sendToPlaza.success`));
          })
          .catch(toastError);
      },
      toggleIsActive() {
        clients.updateClientActiveStatus(this.client)
          .then(() => {
            this.client.isActive = !this.client.isActive;
            toastSuccess(this.$t(`messages.clients.${this.client.isActive ? 'activate' : 'deactivate'}.success`));
            this.onClientUpdated();
          })
          .catch(toastError);
      },
      updateClientData() {
        clients.updateClientData(this.clientModel)
          .then(() => {
            this.onClientUpdated();
            this.toggleClientViewMode();
            toastSuccess(this.$t(`messages.clients.update.success`));
          })
          .catch(toastError);
      },
      getClientLoyaltyCards() {
        clients.getClientCards(this.$route.params.clientId)
          .then(({ data }) => {
            this.loyaltyCards = data;
          });
      },
      showHistoryDetails(historyRow, index) {
        this.clientHistoryDetails = {
          old: historyRow,
          new: this.clientsHistory[index - 1] || { data: this.client },
        };
      },
      closeHistoryRowDetails() {
        this.clientHistoryDetails = null;
      },
      getChildClients() {
        clients.getChildClients(this.$route.params.clientId)
          .then(({ data }) => {
            this.childClients = data;
          });
      },
      getClientsHistory() {
        clients.getClientsHistory(this.$route.params.clientId)
          .then(({ data }) => {
            this.clientsHistory = data;
          });
      },
      getClientData() {
        clients.getClientDetails(this.$route.params.clientId)
          .then(response => {
            const { status, data } = response;
            if (status === 200) {
              this.client = data;
              const clientBranches = data.branchesData.map(i => i.branchId);
              this.missingBranches = [1, 2, 3].filter(i => clientBranches.indexOf(i) === -1);
              this.clientModel = {
                ...data,
              };
            } else if (status === 204) {
              console.log('Nie ma takiego klienta');
            }
          });
      },
      getClientInvoices() {
        clients.getClientInvoices(this.$route.params.clientId)
          .then(({ data }) => {
            this.invoices = data.sort((a, b) => (b.invoiceDate || '').localeCompare(a.invoiceDate || ''));
            this.invoices
              .forEach(invoice => this.invoiceLoyaltyCheckbox[invoice.invoiceId] = !invoice.companyNip || invoice.companyNip === '0' || invoice.loyaltyStatus);
          });
      },
      getClientStays() {
        clients.getClientStays(this.$route.params.clientId)
          .then(({ data }) => {
            this.stays = data.sort((a, b) => (b.dateTo || '').localeCompare(a.dateTo || ''));
          });
      },
      onLoyaltyCardsUpdated() {
        this.getClientData();
        this.getClientLoyaltyCards();
      },
      startLoyaltyBalanceUpdate() {
        this.loyaltyBalanceUpdate = true;
      },
      onLoyaltyBalanceUpdateCancel() {
        this.loyaltyBalanceUpdate = false;
      },
      startParentClientUpdate() {
        this.parentClientUpdate = true;
      },
      onParentClientUpdateCancel() {
        this.parentClientUpdate = false;
      },
      onClientUpdated() {
        this.getClientData();
        this.getClientInvoices();
        this.getClientsHistory();
      }
    },
    mounted() {
      this.getClientData();
      this.getClientInvoices();
      this.getClientStays();
      this.getClientLoyaltyCards();
      this.getChildClients();
      this.getClientsHistory();
    },
  };
</script>

<style scoped>
  .tabs {
    margin-bottom: 1.5rem;
  }
</style>
